import React, { useContext, useState, useEffect } from "react";
import AuthContext from "../../../contexts/auth";
import { translate } from "../../../utils/Common";
import { defaultCatcher } from "../../../config/defaultCatcher";
import { useForm } from "react-hook-form";
import Input from "../../../components/common/Input";
import Select from "../../../components/common/Select";
import Button from "../../../components/common/Button";
import { ConfirmModal } from "../../../components/common/ConfirmModal";
import * as FaIcons from "react-icons/fa";
import { FiEdit2, FiX } from "react-icons/fi";
import styles from "./FormBankInformation.module.css";

const FormBankInformation = ({ userInformation }) => {
  const { handleSubmit, register, formState: { errors }, clearErrors } = useForm();
  const UserContext = useContext(AuthContext);
  const [validate, setValidate] = useState(false);
  const [data, setData] = useState(null);
  const [selectedType, setSelectedType] = useState("1");
  const [editConfirmOpen, setEditConfirmOpen] = useState(false);
  const [alertModal, setAlertModal] = useState({ open: false, title: '', message: '' });

  useEffect(() => {
    const getUserInformation = async () => {
      try {
        const response = await UserContext.bankInfo();
  
        if (response.payload && response.payload.TipoCuenta) {
          setData(response.payload);
          setSelectedType(response.payload.TipoCuenta);
        } else {
          setSelectedType("1");
        }
      } catch (err) {
        defaultCatcher(err);
      }
    };

    getUserInformation();
  }, [UserContext]);

  const handleCancelUpdate = () => {
    clearErrors();
    setValidate(false);
  };

  const handleEditClick = () => setEditConfirmOpen(true);

  const sendUpdate = async (formData) => {
    const response = await UserContext.updateInfoBank(formData);
    if (response.code === 200) {
      setValidate(false);
      setAlertModal({
        open: true,
        title: translate("dashboard.userprofile.personal.successful_update"),
        message: translate("dashboard.userprofile.personal.success_message"),
      });
    } else {
      setAlertModal({
        open: true,
        title: translate("global.alerts.ops"),
        message: translate("login.resetpwd.validate.catchError") + ".",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(sendUpdate)} className={styles.form}>
      <h5 className={styles.sectionTitle}>Datos bancarios</h5>
      
      <div className={styles.formGrid}>
        <Input
          label={translate("global.nameProperty")}
          defaultValue={data?.NombreCuenta ? data?.NombreCuenta : ""}
          disabled={!validate}
          type="text"
          error={errors.nameAccount?.message}
          leftIcon={<FaIcons.FaUniversity size={16} />}
          required
          {...register("nameAccount", {
            required: {
              value: true,
              message: translate("dashboard.userprofile.personal.invalid_name"),
            },
          })}
        />

        <Input
          label={translate("global.numAccount")}
          defaultValue={data?.NumeroCuenta ? data?.NumeroCuenta : ""}
          disabled={!validate}
          type="text"
          error={errors.numAccount?.message}
          leftIcon={<span style={{ fontSize: '16px', fontWeight: 'bold' }}>#</span>}
          required
          {...register("numAccount", {
            required: {
              value: true,
              message: translate("dashboard.userprofile.personal.invalid_name"),
            },
          })}
        />

        <Input
          label={translate("global.bank")}
          defaultValue={data?.Banco ? data?.Banco : ""}
          disabled={!validate}
          type="text"
          error={errors.nameBank?.message}
          leftIcon={<FaIcons.FaUniversity size={16} />}
          required
          {...register("nameBank", {
            required: {
              value: true,
              message: translate("dashboard.userprofile.personal.invalid_name"),
            },
          })}
        />

        <Select
          label={translate("global.typeAccount")}
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          disabled={!validate}
          error={errors.typeAccount?.message}
          required
          options={[
            {
              value: "1",
              label: translate("global.savings")
            },
            {
              value: "2",
              label: translate("global.current")
            }
          ]}
          {...register("typeAccount", {
            required: {
              value: true,
              message: translate("dashboard.userprofile.personal.invalid_name"),
            },
          })}
        />
      </div>

      <div className={styles.actions}>
        {validate && (
          <Button
            variant="outline"
            onClick={handleCancelUpdate}
            leftIcon={<FiX size={16} />}
          >
            {translate("dashboard.userprofile.updatepsw.cancel")}
          </Button>
        )}
        {userInformation &&
          (validate ? (
            <Button 
              variant="primary" 
              type="submit"
              leftIcon={<FiEdit2 size={16} />}
            >
              {translate("dashboard.userprofile.personal.update")}
            </Button>
          ) : (
            <Button
              variant="primary"
              onClick={handleEditClick}
              leftIcon={<FiEdit2 size={16} />}
            >
              {translate("dashboard.userprofile.personal.update")}
            </Button>
          ))}
      </div>

      <ConfirmModal
        isOpen={editConfirmOpen}
        onClose={() => setEditConfirmOpen(false)}
        onConfirm={() => {
          setEditConfirmOpen(false);
          setValidate(true);
        }}
        title={translate("dashboard.userprofile.personal.attention")}
        message={translate("dashboard.userprofile.personal.bankConfirmate")}
        confirmText={translate("dashboard.userprofile.personal.accept")}
        cancelText={translate("dashboard.userprofile.personal.cancel")}
        variant="primary"
      />

      <ConfirmModal
        isOpen={alertModal.open}
        onClose={() => setAlertModal((p) => ({ ...p, open: false }))}
        title={alertModal.title}
        message={alertModal.message}
        confirmText={translate("global.OK")}
        variant="primary"
        showCancelButton={false}
      />
    </form>
  );
};

export default FormBankInformation;
